import { InitialState } from '@client/monolith/legacy/store/account/orderpay/index';
import { SET_ORDERPAY_ACCOUNT_INFO } from '@client/monolith/legacy/store/account/orderpay/mutations-types';
import { GetOrderPayAccountData } from '@ankorstore/api-internal/data-contracts';

export const mutations = {
  [SET_ORDERPAY_ACCOUNT_INFO]: (state: InitialState, payload: GetOrderPayAccountData) => {
    state.status = payload.data;
  },
};
